import React, { Component } from "react";
import ReactDOM from "react-dom";
import axios from "axios"; 
import { getErrorsMessage, getSuccessMessage } from "../utils.js";
import { LangContext } from "../LangContext.jsx";

class HistoryPayments extends Component {
    static contextType = LangContext;

    constructor(props) {
        super(props);
        const defaultLang = this.context || { get: () => {} }; // Asume que lang tiene un método 'get'
        this.state = {
            payments: [],
            isLoading: false, // Estado para indicar carga
            downloadError: null, // Para manejar errores de descarga
        };
    } 

    getMockPayments = () => {
        return [
            {
                date: '2026-03-20 18:47:37',
                transaction_id: '61346134631',
                amount: '$2,000',
                reference_id: '-'
            },
            {
                date: '2026-03-20 18:47:37',
                transaction_id: '31461346134',
                amount: '$7,500',
                reference_id: '31461346134'
            },
            {
                date: '2026-03-20 18:47:37',
                transaction_id: '13451345134',
                amount: '$1,500',
                reference_id: '13451345134'
            },
            {
                date: '2026-03-20 18:47:37',
                transaction_id: '513451345134',
                amount: '$20,000',
                reference_id: '513451345134'
            }
        ];
    }

    getPayments = () => {
        axios.get("/api/zoho/payments")
            .then((res) => {
                const paidPayments = res.data.data.filter(payment => payment.status === 'paid');
                this.setState({ payments: paidPayments.length ? paidPayments : this.getMockPayments() });
            })
            .catch((error) => {
                console.error("Error fetching payments:", error);
                this.setState({ payments: this.getMockPayments() });
            });
    }

    componentDidMount() {
        this.getPayments();
    }

    // Función para descargar el PDF
    downloadInvoicePdf = (invoiceId) => {
        this.setState({ isLoading: true, downloadError: null }); // Inicia el estado de carga

        axios.get(`/api/zoho/invoices/${invoiceId}/pdf`, { responseType: 'blob' })
        .then(response => {
          // Verifica si response.data es un Blob
            if (response.data instanceof Blob) {
            const blob = response.data;
            const url = window.URL.createObjectURL(blob);
            
            // Crear un enlace temporal para descargar el archivo
            const link = document.createElement('a');
            link.href = url;
            link.download = invoiceId+'.pdf';  // Nombre que se le dará al archivo
            link.click();  // Simula el clic para la descarga
            window.URL.revokeObjectURL(url);  // Libera el objeto URL una vez que se haya usado
            } else {
                console.error('La respuesta no es un Blob válido:', response.data);
            }
            })
            .catch(error => {
            console.error('Error descargando el archivo', error);
            });
    }

    render() {
        const { isLoading, downloadError } = this.state;

        return (
            <> 
            <div className="card card-custom mt-5">
                <div className="card-header py-3">
                    <div className="card-title align-items-start flex-column">
                        <h3 className="card-label font-weight-bolder text-dark">Historial de compras</h3>
                    </div> 
                </div> 
                <div className="card-body history-table-card">
                    {downloadError && (
                        <div className="alert alert-danger">
                            {downloadError}
                        </div>
                    )}

                    <div className="table-responsive w-100">
                        <table className="table history-table mb-0">
                            <thead>
                                <tr>
                                    <th>Fecha</th>
                                    <th>No. de pago</th>
                                    <th>Pago</th>
                                    <th>Factura</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.payments.map((payment, index) => (
                                    <tr key={index}>
                                        <td>{payment.date}</td>
                                        <td>{payment.transaction_id}</td>
                                        <td>{payment.amount}</td>
                                        <td>{payment.reference_id}</td>
                                        <td className="text-right">
                                            <button className="btn btn-xs btn-icon btn-light-secondary" onClick={() => this.downloadInvoicePdf(payment.transaction_id)}>
                                                <i className="flaticon2-download text-primary"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            </>
        );
    }
}

export default HistoryPayments;

if (document.getElementById("HistoryPayments")) {
    ReactDOM.render(<HistoryPayments />, document.getElementById("HistoryPayments"));
}
